import { render, staticRenderFns } from "./ProgramHistoryTable.vue?vue&type=template&id=f386ac46&scoped=true&"
import script from "./ProgramHistoryTable.vue?vue&type=script&lang=js&"
export * from "./ProgramHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramHistoryTable.vue?vue&type=style&index=0&id=f386ac46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f386ac46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VIcon,VSimpleTable})
